// ===========================================================
// ERP BARCODE SCANNER - FIXED SCANNING VERSION
// ===========================================================

let scannerActive = false;
let scanTimeout = null;
let currentCamera = "environment";
let scanHistory = [];
const SCAN_COOLDOWN = 1500;
let quaggaInitialized = false;

// Configuration optimized for actual barcode scanning
const SCANNER_CONFIG = {
  inputStream: {
    name: "Live",
    type: "LiveStream",
    constraints: {
      facingMode: currentCamera,
      width: { min: 640, ideal: 1920, max: 1920 },
      height: { min: 480, ideal: 1080, max: 1080 },
      aspectRatio: { min: 1, max: 2 }
    },
    area: {
      top: "20%",
      right: "10%",
      left: "10%",
      bottom: "20%"
    },
    singleChannel: false // important for color barcodes
  },
  locator: {
    patchSize: "large", // better for mobile
    halfSample: false,  // better quality
    debug: {
      showCanvas: false,
      showPatches: false,
      showFoundPatches: false,
      showSkeleton: false,
      showLabels: false,
      showPatchLabels: false,
      showRemainingPatchLabels: false,
      boxFromPatches: {
        showTransformed: false,
        showTransformedBox: false,
        showBB: false
      }
    }
  },
  numOfWorkers: 0,
  frequency: 5, // slower but more accurate
  decoder: {
    readers: [
      "code_128_reader",
      "ean_reader",
      "ean_8_reader",
      "upc_reader",
      "upc_e_reader",
      "code_39_reader",
      "code_93_reader"
    ],
    debug: {
      drawBoundingBox: false,
      showFrequency: false,
      drawScanline: false,
      showPattern: false
    }
  },
  locate: true
};

window.startScanner = function(mode = 'inventory') {
  console.log("Starting scanner...");
  
  if (!document.getElementById('scanner-modal')) {
    createScannerModal();
  }
  
  const modal = document.getElementById('scanner-modal');
  modal.style.display = 'flex';
  scannerActive = true;
  scanHistory = [];
  
  // Load Quagga if not present
  if (typeof Quagga === 'undefined') {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/quagga@0.12.1/dist/quagga.min.js';
    script.onload = () => initQuagga(mode);
    script.onerror = () => alert('Failed to load scanner library');
    document.head.appendChild(script);
  } else {
    initQuagga(mode);
  }
};

function initQuagga(mode) {
  // Ensure clean state
  if (quaggaInitialized) {
    try { Quagga.stop(); } catch(e) {}
  }
  
  const target = document.querySelector('#interactive');
  if (!target) {
    console.error("Target not found");
    return;
  }
  
  // Clear previous content
  target.innerHTML = '';
  
  // Create video element explicitly
  const video = document.createElement('video');
  video.id = 'scanner-video';
  video.style.width = '100%';
  video.style.height = '100%';
  video.style.objectFit = 'cover';
  video.autoplay = true;
  video.playsInline = true; // Important for iOS
  video.muted = true;
  target.appendChild(video);
  
  // Clone config
  const config = JSON.parse(JSON.stringify(SCANNER_CONFIG));
  config.inputStream.target = video;
  
  // Add debug info
  showDebugInfo("Initializing camera...");
  
  Quagga.init(config, function(err) {
    if (err) {
      console.error("Init error:", err);
      showDebugInfo("Error: " + err.message);
      handleInitError(err, mode);
      return;
    }
    
    quaggaInitialized = true;
    showDebugInfo("Camera active - Point at barcode");
    console.log("Scanner ready");
    
    Quagga.start();
    addScannerOverlay();
    setupDetection(mode);
  });
}

function setupDetection(mode) {
  let lastResult = null;
  let count = 0;
  
  Quagga.offDetected();
  Quagga.onDetected(function(result) {
    if (!scannerActive) return;
    
    const code = result.codeResult.code;
    const confidence = result.codeResult.confidence;
    
    // Visual feedback that something is detected
    if (result.box) {
      drawDetectionBox(result.box);
    }
    
    // Must have good confidence
    if (confidence < 0.8) {
      showDebugInfo("Detecting... (" + Math.round(confidence*100) + "%)");
      return;
    }
    
    // Debounce
    const now = Date.now();
    if (scanHistory.find(s => s.code === code && (now - s.time < SCAN_COOLDOWN))) {
      return;
    }
    
    // Require 2 consecutive same reads
    if (lastResult === code) {
      count++;
      if (count >= 2) {
        scanHistory.push({ code: code, time: now });
        if (scanHistory.length > 5) scanHistory.shift();
        
        showDebugInfo("✓ Code: " + code);
        handleScannedCode(code, mode);
        lastResult = null;
        count = 0;
      }
    } else {
      lastResult = code;
      count = 1;
      showDebugInfo("Detected: " + code + " (confirming...)");
    }
  });
  
  // Also listen for processing to see if camera is working
  Quagga.onProcessed(function(result) {
    if (!scannerActive) return;
    
    const drawingCanvas = Quagga.canvas.dom.overlay;
    if (drawingCanvas) {
      drawingCanvas.style.display = 'none'; // Hide default overlay
    }
  });
}

function drawDetectionBox(box) {
  let overlay = document.querySelector('.detection-box');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'detection-box';
    overlay.style.cssText = `
      position: absolute;
      border: 3px solid #10b981;
      background: rgba(16, 185, 129, 0.1);
      z-index: 20;
      transition: all 0.1s;
      pointer-events: none;
    `;
    document.querySelector('#interactive').appendChild(overlay);
  }
  
  // Simple positioning (approximate)
  const container = document.querySelector('#interactive');
  const rect = container.getBoundingClientRect();
  
  overlay.style.left = (box[0][0] / rect.width * 100) + '%';
  overlay.style.top = (box[0][1] / rect.height * 100) + '%';
  overlay.style.width = ((box[1][0] - box[0][0]) / rect.width * 100) + '%';
  overlay.style.height = ((box[2][1] - box[0][1]) / rect.height * 100) + '%';
  overlay.style.display = 'block';
}

function showDebugInfo(text) {
  let debug = document.getElementById('scanner-debug');
  if (!debug) {
    debug = document.createElement('div');
    debug.id = 'scanner-debug';
    debug.style.cssText = `
      position: absolute;
      bottom: 10px;
      left: 10px;
      right: 10px;
      background: rgba(0,0,0,0.7);
      color: #10b981;
      padding: 8px;
      border-radius: 4px;
      font-family: monospace;
      font-size: 12px;
      z-index: 30;
      text-align: center;
    `;
    document.querySelector('#interactive').appendChild(debug);
  }
  debug.textContent = text;
  console.log("Scanner:", text);
}

function handleInitError(err, mode) {
  if (err.name === 'NotAllowedError') {
    alert("Camera permission denied! Please allow camera access in browser settings and reload.");
  } else if (err.name === 'NotFoundError') {
    alert("No camera found. Ensure your device has a camera.");
  } else if (err.name === 'NotReadableError') {
    alert("Camera is in use by another app. Close other apps using camera.");
  } else if (err.message.includes("constructor") || err.message.includes("worker")) {
    // Try without locator
    tryFallbackConfig(mode);
  } else {
    alert("Camera error: " + err.message);
  }
}

function tryFallbackConfig(mode) {
  showDebugInfo("Trying fallback mode...");
  
  const config = {
    inputStream: {
      name: "Live",
      type: "LiveStream",
      target: document.querySelector('#scanner-video'),
      constraints: {
        facingMode: currentCamera,
        width: 1280,
        height: 720
      }
    },
    locator: {
      patchSize: "x-large",
      halfSample: true
    },
    numOfWorkers: 0,
    frequency: 10,
    decoder: {
      readers: ["code_128_reader", "ean_reader"]
    },
    locate: false // Disable locator for problematic devices
  };
  
  Quagga.init(config, function(err) {
    if (err) {
      showDebugInfo("Fallback failed: " + err.message);
      return;
    }
    quaggaInitialized = true;
    Quagga.start();
    setupDetection(mode);
    showDebugInfo("Fallback mode active");
  });
}

function handleScannedCode(code, mode) {
  if (navigator.vibrate) navigator.vibrate(200);
  
  // Visual success
  const debug = document.getElementById('scanner-debug');
  if (debug) debug.style.background = '#10b981';
  if (debug) debug.style.color = 'white';
  
  setTimeout(() => {
    window.stopScanner();
    processCode(code, mode);
  }, 500);
}

function processCode(code, mode) {
  console.log("Final scan:", code);
  
  if (mode === 'attendance') {
    const input = document.getElementById('attendance-employee-id');
    if (input) {
      input.value = code;
      input.dispatchEvent(new Event('input'));
      if (typeof window.handleAttendanceSubmit === 'function') {
        window.handleAttendanceSubmit(code);
      }
    }
  } else {
    const searchInput = document.getElementById('inv-search');
    if (searchInput) {
      searchInput.value = code;
      searchInput.style.background = "#dcfce7";
      setTimeout(() => searchInput.style.background = "", 1000);
      searchInput.dispatchEvent(new Event('input'));
      if (typeof window.filterInventory === 'function') {
        window.filterInventory();
      }
    }
  }
  
  showScanSuccess(code);
}

// ... (keep createScannerModal, addScannerOverlay, showScanSuccess, stopScanner same but with these updates)

window.stopScanner = function() {
  scannerActive = false;
  
  if (typeof Quagga !== 'undefined' && quaggaInitialized) {
    try {
      Quagga.offDetected();
      Quagga.offProcessed();
      Quagga.stop();
      quaggaInitialized = false;
    } catch(e) {}
  }
  
  const modal = document.getElementById('scanner-modal');
  if (modal) modal.style.display = 'none';
  
  // Cleanup
  const interactive = document.querySelector('#interactive');
  if (interactive) interactive.innerHTML = '';
};

function createScannerModal() {
  if (document.getElementById('scanner-modal')) return;
  
  const modal = document.createElement('div');
  modal.id = 'scanner-modal';
  modal.style.cssText = `
    display: none;
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.95);
    z-index: 9999;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  `;
  
  modal.innerHTML = `
    <div style="
      background: #1f2937;
      padding: 20px;
      border-radius: 16px;
      width: 95%;
      max-width: 600px;
      position: relative;
    ">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
        <h3 style="margin: 0; color: white; font-size: 18px;">📷 Scan Barcode</h3>
        <button onclick="window.stopScanner()" style="
          background: #ef4444;
          color: white;
          border: none;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 20px;
          line-height: 1;
        ">×</button>
      </div>
      <div id="interactive" style="
        height: 400px;
        background: #000;
        border-radius: 12px;
        overflow: hidden;
        position: relative;
        border: 2px solid #374151;
      "></div>
      <div style="margin-top: 15px; display: flex; gap: 10px; justify-content: center; flex-wrap: wrap;">
        <button onclick="window.switchCamera()" style="
          background: #4b5563;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
        ">🔄 Switch Camera</button>
        <button onclick="window.toggleTorch()" style="
          background: #f59e0b;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 14px;
        ">💡 Flash</button>
      </div>
      <div style="margin-top: 10px; text-align: center; color: #9ca3af; font-size: 12px;">
        Hold camera steady, ensure good lighting
      </div>
    </div>
  `;
  
  document.body.appendChild(modal);
}

window.toggleTorch = async function() {
  try {
    const stream = document.querySelector('#scanner-video')?.srcObject;
    if (!stream) return;
    
    const track = stream.getVideoTracks()[0];
    const capabilities = track.getCapabilities();
    
    if (capabilities.torch) {
      const settings = track.getSettings();
      await track.applyConstraints({
        advanced: [{ torch: !settings.torch }]
      });
    }
  } catch(e) {
    console.log("Torch not supported");
  }
};

window.switchCamera = function() {
  window.stopScanner();
  currentCamera = currentCamera === "environment" ? "user" : "environment";
  SCANNER_CONFIG.inputStream.constraints.facingMode = currentCamera;
  setTimeout(() => window.startScanner(), 300);
};